import { useSmoothScroll } from "@/hooks/useSmoothScroll";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import SustainabilityHero from "./components/SustainabilityHero";
import ImpactStats from "./components/ImpactStats";
import InitiativesGrid from "./components/InitiativesGrid";
import MaterialsSection from "./components/MaterialsSection";
import Certifications from "./components/Certifications";

export default function Sustainability() {
  useSmoothScroll();

  return (
    <div className="min-h-screen bg-bone text-ink">
      <Navbar />
      <main>
        <SustainabilityHero />
        <ImpactStats />
        <InitiativesGrid />
        <MaterialsSection />
        <Certifications />
      </main>
      <Footer />
    </div>
  );
}